export default {
  page: {
    title: 'Promotion materials',
  },
  tabs: {
    banner: 'Banner',
    landing: 'Landing',
    video: 'Video',
    gif: 'GIF',
    logo: 'Logo',
  },
  filter: {
    activity: 'Campaign',
    size: 'Size',
    language: 'Language',
    search: 'Search',
    reset: 'Reset',
    allActivity: 'All campaigns',
  },
  baseCard: {
    getCode: 'Get code',
    view: 'View',
    download: 'Download',
  },
  drawer: {
    title: 'Get code',
    view: 'View',
    download: 'Download',
    copy: 'Copy',
    copySuccess: 'Copied',
    copyFail: 'Copy failed',
    noImage: 'No image',
  },
  getCodeDrawer: {
    size: 'Size',
    language: 'Language',
    platform: 'Platform',
    code: 'Code',
    loop: 'Loop',
    muted: 'Muted',
    autoplay: 'Autoplay',
  },
  logo: {
    options: {
      open: 'Open',
      close: 'Close',
      all: 'All',
    },
  },
}
